// extracted by mini-css-extract-plugin
export default {"intro":"Posts_intro__bgoiJ"};